<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Configuración productos</h4>
				</div>
				<div class="modal-body">
					<loading :active="loading">
						<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
					</loading>
					<div class="row">
						<div class="col-md-12">
							<div class="panel-group">
								<div class="panel panel-default">
									<div class="panel-heading">
										<router-link :to="goTo('products/attributes')" @click.native="close">
											<h4 class="panel-title">
												Atributos
											</h4>
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-setting-products'
				},
				loading: false,
			}
		},
		methods: {
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			goTo(to) {
				var menu = null
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.menu) {
							menu = this.$route.meta.menu
						}
					}
				}

				if(menu) {
					if(menu == 'dashboard') {
						var to = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + to
					} else {
						var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + menu + '/' + to
					}
				} else {
					var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + to
				}

				return to
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/views/Products.vue